<div class="row rms-tree-item-picker">
  <div class="col-xs-12 col-md-8">
    <div class="form-group">
      <label for="treePickerFilter">{{filterLabel}}</label>
      <input type="text" id="treePickerFilter" class="form-control" [placeholder]="searchPlaceholder"
             [ngModel]="searchField" (ngModelChange)="filterChanged($event)">
    </div>
    <div class="rms-tip-list bordered-box">
      <table class="table" *ngIf="convertedItems.length > 0">
        <thead>
          <tr>
            <th>
              <div class="checkbox">
                <input type="checkbox" id="bulk" name="bulk" (change)="bulkSelect()" [(ngModel)]="bulkCheckSelect">
                <label for="bulk">{{"MY_COMPANIES.COMPANY_NAME" | translate}}</label>
              </div>
            </th>
            <th>{{"MY_COMPANIES.PUBLIC_PRIVATE" | translate}}</th>
          </tr>
        </thead>
        <tbody>
          <tr *ngFor="let item of convertedItems">
            <td>
              <div class="checkbox">
                <input type="checkbox" [id]="item.id" [name]="item.id" (change)="itemChanged(item)" [(ngModel)]="item.isChecked">
                <label [for]="item.id">{{item.label}}</label>
              </div>
            </td>
            <td>{{item.columnValue ? 'Private' : 'Public'}}</td>
          </tr>
        </tbody>
      </table>
    </div>
  </div>
  <div class="col-xs-12 col-md-4">
    <span class="fake-label">{{btnLabel ? btnLabel : selectedListLabel}}</span>
    <div class="rms-tip-selected-items bordered-box">
      <ul>
        <li *ngFor="let item of itemsAdded" (click)="removeSelectedItem(item)">{{item.label}}</li>
      </ul>
    </div>
  </div>
  <div class="col">
    <button type="button" class="btn btn-primary" (click)="addCheckedItems()">
      {{btnLabel ? btnLabel : selectedListLabel}}
    </button>
  </div>
</div>
